import { useMutation } from '@tanstack/react-query'

import { getNewPassword } from '../auth.api'

export const useGetNewPassword = () => {
  return useMutation({
    mutationFn: (username: string) => getNewPassword(username),
  })
}
